var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileAddBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -10,
    y: -10,
    width: 95,
    height: 95
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      clipPath: "url(#bgblur_0_3289_14826_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 10
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    rx: 37.5,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 22,
    width: 4,
    height: 32,
    rx: 2,
    fill: "#1D1D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 32,
    rx: 2,
    transform: "matrix(0 -1 -1 0 53 40)",
    fill: "#1D1D1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_3289_14826_clip_path",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    rx: 37.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAddBtn);
export default __webpack_public_path__ + "static/media/mobileAddBtn.19460e899aa2810578ad2baba0402f47.svg";
export { ForwardRef as ReactComponent };